<template>
  <b-modal 
    id="whats_new_modal"
    :title="pageHelp.title"
    :visible="value"
    :footer="pageHelp.footer"
    hide-header-close 
    ok-only
    size="lg"
    @show="showHelpModal"
    hide-backdrop content-class="shadow" 
  >
    <b-container fluid>
      <div v-for="line in pageHelp.body" :key="line">
        <div class='helpBodyPara'>{{ line }}</div>
      </div>
    </b-container >


    <template v-slot:modal-footer>
      <div class="w-100">
      <b-row>
        <b-col md="9" class="footerText">{{ pageHelp.footer }}</b-col>
        <b-col md="1"></b-col>
        <b-col md="2" >
          <b-button variant="primary" class="float-right" @click="value=false">OK</b-button>
        </b-col>
      </b-row>
      </div>
    </template>

  </b-modal>
</template>

<script>
import helpTextJson from './whatsNewHelpText.json';

export default {
  name: 'whats_new_modal',
  props: ['value'],
  mounted() {
    this.$root.$on('bv::modal::hide', (bvModalEvt) => {
      if (bvModalEvt.componentId === 'whats_new_modal') {
        this.$emit('input', false)
      }
    }),
    this.getHelpTextObject()
  },
  data() {
    return {
        pageHelp: { 
          title : "[This is the title]", 
          body : "[This is the body text.]", 
          footer : "If you have questions about an RFQ, please reach out to the salesperson that sent it. Thank you! "},
    };
  },
  methods: {
    getHelpTextObject() {
      var helpKey = this.$route.meta.helpKey; 

      // Get the help info for this page/route's helpKey
      var helpObject = helpTextJson.find(item => item.helpKey == helpKey);

      // Each helpObject contains properties for the header, body and footer. 
      // .body is an array of paragraph strings.
      var pageHelp = helpObject.helpText;  
      //console.log(pageHelp.body);

      this.pageHelp = pageHelp;
    },
    
    showHelpModal(evt) {
      this.getHelpTextObject();
    }
  }
}

</script>
<style scoped>
.footerText {
  font-size: 85%;
  color: #666666  ;
  font-style: italic;
}

.helpBodyPara {
  margin-bottom: 8px;
}
</style>